[
  {
    "slug": "v0-75-2",
    "title": "v1.4.0 – Billing System Improvements",
    "date": "2026-02-10",
    "description": "We've rolled out a major update to the billing system to improve transparency and give authors more control over their revenue and invoices.",
    "tags": [
      "billing",
      "release"
    ],
    "published": true,
    "rawContent": "![Redesigned Billing dashboard preview](/data/posts/v0-75-2/screenshot.svg)\n\n### New\n- Introduced a redesigned Invoices table with improved readability and new status indicators\n- Added Due Date column to help track upcoming and overdue payments\n- Implemented Revenue Share breakdown per platform\n\n### Improvements\n- Updated layout of Summary cards for better financial overview\n- Improved structure of Additional Services to make extra charges clearer\n- Refined system statuses across billing scenarios\n\n### Fixes\n- Fixed an issue where invoice totals were displayed incorrectly in edge cases\n- Resolved inconsistencies in subscription renewal dates"
  }
]
